import React from 'react';
import ReactDOM from 'react-dom';
import { CloseOutlined } from '@ant-design/icons';
import '../styles/components/popup.scss';

const modalRoot = document.getElementById('modal-root');

class PopUp extends React.Component {
  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  setWrapperRef = (node) => {
    this.wrapperRef = node;
  };

  handleClickOutside = (event) => {
    if (
      this.wrapperRef &&
      !this.wrapperRef.contains(event.target) &&
      this.props.closeOnOutClick
    ) {
      this.props.closePopUp();
    }
  };

  render() {
    return ReactDOM.createPortal(
      <div className={`popup ${this.props.className}`} style={this.props.style}>
        <div className="popup-body" ref={this.setWrapperRef}>
          <button
            type="button"
            className="popup--close"
            onClick={this.props.closePopUp}
          >
            <CloseOutlined />
          </button>
          {React.cloneElement(this.props.children, this.props)}
        </div>
      </div>,
      modalRoot
    );
  }
}

PopUp.defaultProps = {
  closeOnOutClick: true,
};

export default PopUp;
